import { useDataChange, useDataSubmit } from 'Simple/Data.js'

export function isLast(selected, manual_action_executions) {
  return selected.index === manual_action_executions.length - 1
}

export function getActionName(selected) {
  return (
    selected.trigger_type === 'pre' &&
    selected.action_type === 'check_requirements'
  )
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'manual_action_executions',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'manual_action_executions',
    viewPath: props.viewPath,
  })

  return function onClick() {
    // mark all actions as cancelled and submit
    change(next => {
      for (let item of next) {
        item.status = 'cancelled'
      }
    })
    // run on the next cycle so the first change takes effect
    setTimeout(submit, 100)
  }
}
